export default __webpack_public_path__ + "static/media/moins.00dfbf86.svg";